import {FULFILLED} from 'redux-promise-middleware';
import {ActionType as ReduxActionType} from 'redux-actions';

import {CUSTOMER} from 'constants/actions';

import {doTransform} from 'libs/transformers';
import {call, select, take, takeEvery} from 'redux-saga/effects';
import {getCustomer} from 'selectors/customer/customer';
import {preparationDataForTrackConversionEmailLead} from 'sagas/analytics/impactRadius/trackConversion';
import {setCustomerEmail} from 'reducers/analytics/impactRadius';

/**
 * Identify customer.
 *
 * @param {string} email - Customer email.
 */
export function* identifyCustomer(email: string) {
    try {
        const hashedEmail = email === '' ? '' : yield call(doTransform, email, 'sha1');
        if (window.ire)
            yield call(window.ire, 'identify', {
                customerId: hashedEmail,
                customerEmail: hashedEmail,
            });
    } catch (error) {
        yield call([console, 'log'], error);
    }
}

/**
 * Identify customer when the page loads.
 */
export function* captureCustomerForResponse() {
    yield take(`${CUSTOMER.GET_CUSTOMER_DATA}_${FULFILLED}`);
    const {email} = yield select(getCustomer);
    yield call(identifyCustomer, email);
}

/**
 * Capture the client after subscription.
 *
 * @param {ReduxActionType<setCustomerEmail>} action - Current action.
 */
export function* captureCustomerForSubscribe({payload}: ReduxActionType<typeof setCustomerEmail>) {
    yield take(`${CUSTOMER.GET_CUSTOMER_DATA}_${FULFILLED}`);
    const {email} = payload;
    yield call(identifyCustomer, email);
    yield call(preparationDataForTrackConversionEmailLead, email);
}

/**
 * Begin of saga.
 */
export default function* identify() {
    yield call(captureCustomerForResponse);
    yield takeEvery(setCustomerEmail, captureCustomerForSubscribe);
}
